import React from "react";

const TextInput = ({ name, value, label, options, onChange }) => {
  return (
    <div className="row">
      <div className="col-12 mb-3  pr-2 form-group">
        {label ? <label>{label}</label> : ""}
        <textarea
          className="form-control"
          rows={options.rows}
          name={name}
          onChange={(event) => onChange(event.target.name, event.target.value)}
          value={value}
        ></textarea>
      </div>
    </div>
  );
};

export default TextInput;
